module.exports = __webpack_public_path__ + "static/bg03-c9e8012fc2a3ae2ccf2f0f326a6bcadd.jpg";